<template>
  <div>
    <IncomingCallsFilter v-model:search="search"
      v-model:dates="dates"
      v-model:callStatuses="callStatuses" />
    <IncomingCallsStats :filters="filters" />
    <IncomingCallsChart :filters="filters" />
    <IncomingCallsTable :filters="filters" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { dateWithoutTime, daysAgo } from '../../utils/dates'

import IncomingCallsFilter from './incoming_calls_filter.vue'
import IncomingCallsStats from './incoming_calls_stats.vue'
import IncomingCallsChart from './incoming_calls_chart.vue'
import IncomingCallsTable from './incoming_calls_table.vue'

const today = dateWithoutTime(new Date())
const defaultDateRange = [daysAgo(29), today]
const dates = ref(defaultDateRange)
const search = ref('')
const callStatuses = ref(['answered', 'voicemail', 'missed', 'canceled'])

const filters = computed(() => ({
  dates: dates.value,
  search: search.value,
  callStatuses: callStatuses.value
}))

</script>
